<script setup>
import DetailPanelQuickUsage from './DetailPanelQuickUsage.vue';
import { useYongsinLightData } from '@/composables/yongsinLight/useYongsinLightData';

const props = defineProps({
  guestUserId: {
    required: true,
  },
  contentData: {
    type: Object,
    default: null,
  },
});

const apiDataRef = computed(() => props.contentData);
const { quickUsageData } = useYongsinLightData(apiDataRef);
</script>

<template>
  <div class="desc-header">
    <div class="desc-nav">
      <button class="nav-button active">
        나의 용신 한 눈에
      </button>
    </div>
    <i class="bot-button"></i>
  </div>

  <div class="desc-container w-100">
    <div class="inner">
      <div class="main-card youngsin-tab">
        <DetailPanelQuickUsage :contentData="quickUsageData" />
      </div>
    </div>
  </div>
</template>
